import * as React from 'react';
import {Formik, Form, Field} from 'formik';
import { Button } from '@material-ui/core';
import { TextField, Checkbox } from 'formik-material-ui';
import Grid from "@material-ui/core/Grid/Grid";
import { makeStyles } from '@material-ui/core/styles';
import Alert from "@material-ui/lab/es/Alert/Alert";
import BaseStyles from "./../Membership/BaseStyles";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import { Select } from 'formik-material-ui';
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import Typography from "@material-ui/core/es/Typography/Typography";
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import BlockIcon from '@material-ui/icons/Block';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import InputAdornment from "@material-ui/core/es/InputAdornment/InputAdornment";
import AccountCircle from "@material-ui/icons/AccountCircle";
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import BusinessIcon from '@material-ui/icons/Business';
import LanguageIcon from '@material-ui/icons/Language';
import DealerSignUpRequest from "./DealerSignUpRequest";
import NotifyRequest from "../Notify/NotifyRequest";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        marginBottom: 50,
        ['@media (min-width:500px)']: {
            minWidth: 909
        }
    },
    icon: {
        marginRight: 10,
    },
    loader: {
        marginLeft: 15,
    },
    planBox: {
        width: '100%',
        maxWidth: 500,
        boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);',
        '& ul': {
            listStyle: 'none',
            marginTop: 20,
        },
        '& li': {
            fontSize: '0.7',
            paddingLeft: 40,
            position: 'relative',
            marginBottom: 10
        }
    },
    headerFree: {
        height: 25
    },
    headerPopular: {
        backgroundColor: '#2681eb',
        width: '100%',
        paddingTop: 3,
        textAlign: 'center',
        height: 22,
    },
    headerBest: {
        backgroundColor: 'green',
        width: '100%',
        paddingTop: 3,
        textAlign: 'center',
        height: 22
    },
    headerText: {
        color: '#fff',
        fontSize: '0.8rem'
    },
    planBody: {
        padding: 20,
    },
    title: {
        textAlign: 'center',
    },
    value: {
        textAlign: 'center',
        '& h3': {
            fontSize: '2rem',
        }
    },
    description: {
        textAlign: 'center',
        fontSize: '0.7rem',
        marginTop: 10,
        paddingBottom: 20,
        borderBottom: '1px solid #ccc',
    },
    planSelect: {
        textAlign: 'center',
        marginTop: 30
    },
    doneIcon: {
        position: 'absolute',
        left: 0,
        top: 5,
        color: 'green'
    },
    blockIcon: {
        position: 'absolute',
        left: 0,
        top: 5,
        color: 'gray'
    },
    ...BaseStyles,
    select: {
        width: '100%',
        maxWidth: 690,
        marginTop: 15,
    },
    btn: {
        width: '100%',
        backgroundColor: 'green',
        '&:hover': {
            backgroundColor: 'darkgreen',
        }
    },
    btnPopular: {
        width: '100%',
        ['@media (max-width:700px)']: {
            backgroundColor: '#2681eb',
            '&:hover': {
                backgroundColor: '#2681eb',
            },
            '&:active': {
                backgroundColor: '#2681eb',
            }
        },
        backgroundColor: 'green',
        '&:hover': {
            backgroundColor: 'darkgreen',
        }
    },
    btnSelected: {
        width: '100%',
        backgroundColor: 'white',
        '&:hover': {
            backgroundColor: 'white',
        }
    },
    confidence: {
        marginLeft: 7,
        marginRight: 7,
        marginTop: 10,
    },
    form: {
        marginLeft: 30,
        height: 637,
        ['@media (max-width:700px)']: {
            marginLeft: 0,
            height: 657
        },
        maxWidth: 400,
        boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);',
        paddingTop: 30,
        paddingLeft: 30,
        paddingRight: 30,
    },
    contactLabel: {
        marginLeft: 8,
        marginBottom: 10,
        fontWeight: 'bold',
        fontSize: '1.5em'
    },
    contactCompanyLabel: {
        marginLeft: 8,
        marginBottom: 10,
        marginTop: 10,
    },
    successBox: {
        marginTop: 20,
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '100%',
        maxWidth: 500,
        ['@media (max-width:700px)']: {
            maxWidth: 330,
        },
        boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);',
        padding: 30,
        textAlign: 'center',
        '& h2': {
            paddingBottom: 30,
            fontWeight: 'normal',
            fontSize: '2.5rem'
        }
    }

}));

export default function DealerSignupForm(props) {

    const classes = useStyles();

    const [submitting, setSubmitting] = React.useState();
    const [values, setValues] = React.useState();
    const [isRequested, setIsRequested] = React.useState();
    const [error, setError] = React.useState();
    const [data, setData] = React.useState();
    const [subject, setSubject] = React.useState('Please, select');
    const [selectedPlan, setSelectedPlan] = React.useState('');
    const [scrolled, setScrolled] = React.useState();
    const formRef = React.createRef();


    const onError = e => {
        setIsRequested(false);
        if (submitting) {
            submitting(false);
        }
        setError(e);
    };

    const onData = d => {
        setIsRequested(false);
        setError(null);
        setData(d);
    };

    const handleSelectPlan = (planName) => {
        setSelectedPlan(planName)
        if (planName) {
            setScrolled(false);
        }
    };

    React.useEffect(() => {
        if (!scrolled && selectedPlan && formRef && formRef.current) {
            window.scrollTo(0, formRef.current.offsetTop - 30);
            setScrolled(true);
        }
    })

    const freePlan = <div className={classes.planBox}>
        <div className={classes.headerFree}>

        </div>
        <div className={classes.planBody}>
            <div className={classes.title}>
                <Typography><h2>Free</h2></Typography>
            </div>
            <div className={classes.value}>
                <Typography><h3>$0 / mo.</h3></Typography>
            </div>
            <div className={classes.description}>
                <Typography>Provides free service and exposure for your business. Free to use the platform and occasional leads!</Typography>
            </div>
            <ul className={classes.features}>
                <li className={classes.enabled}>
                    <DoneOutlineIcon className={classes.doneIcon}/>
                    <Typography>Lead generation on Dash Car Sales Marketplace</Typography>
                </li>
                <li className={classes.enabled}>
                    <DoneOutlineIcon className={classes.doneIcon}/>
                    <Typography>Google Search Exposure</Typography>
                </li>
                <li className={classes.enabled}>
                    <DoneOutlineIcon className={classes.doneIcon}/>
                    <Typography>Dash Car Sales members marketing campaigns and recommendations for your vehicles</Typography>
                </li>
                <li className={classes.enabled}>
                    <BlockIcon className={classes.blockIcon}/>
                    <Typography>Craig’s List Optimized ads with unique descriptions and SEO keywords</Typography>
                </li>
                <li className={classes.enabled}>
                    <BlockIcon className={classes.blockIcon}/>
                    <Typography>Promotion within Dash Car Sales Social Networks</Typography>
                </li>
            </ul>
            <div className={classes.planSelect}>
                {selectedPlan ?
                    <Button
                        variant="outlined" color="primary"
                        disabled={isRequested}
                        onClick={() => handleSelectPlan(null)}
                        type="submit"
                    >
                        <ArrowBackOutlinedIcon/> Change Plan
                    </Button>
                    :
                <Button
                    className={classes.btn}
                    variant="contained"
                    color="primary"
                    disabled={isRequested}
                    onClick={() => handleSelectPlan('free')}
                    type="submit"
                >
                    Select
                </Button>}
            </div>
        </div>
    </div>;


    const startUpPlan = <div className={classes.planBox}>
        <div className={classes.headerPopular}>
            <Typography className={classes.headerText}>POPULAR</Typography>
        </div>
        <div className={classes.planBody}>
            <div className={classes.title}>
                <Typography><h2>Start-Up</h2></Typography>
            </div>
            <div className={classes.value}>
                <Typography><h3>$49 / mo.</h3></Typography>
            </div>
            <div className={classes.description}>
                <Typography>Ideal for start-ups and small size independent dealers. We will get you started!</Typography>
            </div>
            <ul className={classes.features}>
                <li className={classes.enabled}>
                    <DoneOutlineIcon className={classes.doneIcon}/>
                    <Typography>Lead generation on Dash Car Sales Marketplace</Typography>
                </li>
                <li className={classes.enabled}>
                    <DoneOutlineIcon className={classes.doneIcon}/>
                    <Typography>Google Search Exposure</Typography>
                </li>
                <li className={classes.enabled}>
                    <DoneOutlineIcon className={classes.doneIcon}/>
                    <Typography>Dash Car Sales members marketing campaigns and recommendations for your vehicles</Typography>
                </li>
                <li className={classes.enabled}>
                    <DoneOutlineIcon className={classes.doneIcon}/>
                    <Typography> 5 Craig’s List Optimized ads with unique descriptions and SEO keywords</Typography>
                </li>
                <li className={classes.enabled}>
                    <DoneOutlineIcon className={classes.doneIcon}/>
                    <Typography>Promotion within Dash Car Sales Social Networks</Typography>
                </li>
            </ul>
            <div className={classes.planSelect}>
                {selectedPlan ?
                    <Button
                        variant="outlined" color="primary"
                        disabled={isRequested}
                        onClick={() => handleSelectPlan(null)}
                        type="submit"
                    >
                        <ArrowBackOutlinedIcon/> Change Plan
                    </Button>
                    :
                <Button
                    className={classes.btnPopular}
                    variant="contained"
                    color="primary"
                    disabled={isRequested}
                    onClick={() => handleSelectPlan('startUp')}
                    type="submit"
                >
                    Select
                </Button>}
            </div>
        </div>
    </div>;

    const businessPlan = <div className={classes.planBox}>
        <div className={classes.headerBest}>
            <Typography className={classes.headerText}>BEST VALUE</Typography>
        </div>
        <div className={classes.planBody}>
            <div className={classes.title}>
                <Typography><h2>Business</h2></Typography>
            </div>
            <div className={classes.value}>
                <Typography><h3>$199 / mo.</h3></Typography>
            </div>
            <div className={classes.description}>
                <Typography>Ideal for mid and bigger size dealers. Provides best value and the most sales!</Typography>
            </div>
            <ul className={classes.features}>
                <li className={classes.enabled}>
                    <DoneOutlineIcon className={classes.doneIcon}/>
                    <Typography>Lead generation on Dash Car Sales Marketplace</Typography>
                </li>
                <li className={classes.enabled}>
                    <DoneOutlineIcon className={classes.doneIcon}/>
                    <Typography>Google Search Exposure</Typography>
                </li>
                <li className={classes.enabled}>
                    <DoneOutlineIcon className={classes.doneIcon}/>
                    <Typography>Dash Car Sales members marketing campaigns and recommendations for your vehicles</Typography>
                </li>
                <li className={classes.enabled}>
                    <DoneOutlineIcon className={classes.doneIcon}/>
                    <Typography>20 Craig’s List Optimized ads with unique descriptions and SEO keywords</Typography>
                </li>
                <li className={classes.enabled}>
                    <DoneOutlineIcon className={classes.doneIcon}/>
                    <Typography>Promotion within Dash Car Sales Social Networks</Typography>
                </li>
            </ul>
            <div className={classes.planSelect}>
                {selectedPlan ?
                    <Button
                        variant="outlined" color="primary"
                        disabled={isRequested}
                        onClick={() => handleSelectPlan(null)}
                        type="submit"
                    >
                        <ArrowBackOutlinedIcon/> Change Plan
                    </Button>
                    :
                    <Button
                        className={classes.btn}
                        variant="contained"
                        color="primary"
                        disabled={isRequested}
                        onClick={() => handleSelectPlan('business')}
                        type="submit"
                    >
                        Select
                    </Button>
                }
            </div>
        </div>
    </div>

    const planMap = {
        startUp: startUpPlan,
        business: businessPlan,
        free: freePlan
    };

    const getDataAsString = (params) => {
        let str = '';
        if (params) {
            for (let i in params) {
                str += i + ": " + params[i] + ', ';
            }
        }
        return str;
    };

    return (
        <div className={classes.root}>
            {isRequested ? <DealerSignUpRequest values={{...values, plan: selectedPlan}} onError={onError} onData={onData}/> : null}
            {data ? <div className={classes.successBox}>
                <Typography><h2>Thank you!</h2></Typography>
                <Typography>We appreciate your interest! Our manager will reach out to you shortly to get you started with the Dash Car Sales marketplace, setting up integrations and getting immediate leads for your business! Please do not hesitate to contact us in the meantime.</Typography>
                <NotifyRequest data={"Signed Up: "+getDataAsString({...values, plan: selectedPlan})}/>
            </div> : null }
            {!data ?
                <div>
                    {selectedPlan ? <>
                        <NotifyRequest data={"Plan selected: "+selectedPlan}/>
                        <Grid container spacing={2} className={classes.grid}>
                            <Grid item xs={12} md={4}>
                                {planMap[selectedPlan]}
                            </Grid>
                            <Grid item xs={12} md={8}>

                                <div className={classes.form} ref={formRef}>
                                    {error ? <>
                                        <Alert severity="warning" className={classes.warning}>{error.message}</Alert>
                                        <NotifyRequest data={"Sign Up Error: "+error.message+" Data: "+getDataAsString({...values, plan: selectedPlan})}/>
                                    </> : null }
                                    <h3><Typography className={classes.contactLabel}>Contact information</Typography></h3>
                                    <Formik
                                        initialValues={{
                                        }}
                                        validate={values => {
                                            const errors = {};
                                            if (!values.email) {
                                                errors.email = 'Required';
                                            } else if (
                                                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
                                            ) {
                                                errors.email = 'Invalid email address';
                                            }
                                            if (!values.phone) {
                                                errors.phone = 'Required';
                                            }
                                            if (!values.name) {
                                                errors.name = 'Required';
                                            }
                                            if (!values.company) {
                                                errors.company = 'Required';
                                            }
                                            return errors;
                                        }}
                                        onSubmit={(values, { setSubm }) => {
                                            console.log(values)
                                            setSubmitting(setSubm);
                                            setValues(values);
                                            setIsRequested(values)
                                        }}
                                    >
                                        {({ submitForm, isSubmitting }) => (
                                            <Form className="form">
                                                <Grid container spacing={2} className={classes.grid}>
                                                    <Grid item xs={12} sm={12}>
                                                        <Field
                                                            className={classes.input}
                                                            component={TextField}
                                                            name="name"
                                                            type="name"
                                                            label="Owner / Representative Name"
                                                            required
                                                            disabled={isRequested}
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <AccountCircle />
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={12}>
                                                        <Field className={classes.input}
                                                               disabled={isRequested}
                                                               component={TextField}
                                                               name="email"
                                                               type="email"
                                                               label="Email"
                                                               required
                                                               InputProps={{
                                                                   startAdornment: (
                                                                       <InputAdornment position="start">
                                                                           <EmailIcon />
                                                                       </InputAdornment>
                                                                   ),
                                                               }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={12}>
                                                        <Field className={classes.input}
                                                               disabled={isRequested}
                                                               component={TextField}
                                                               type="phone"
                                                               label="Phone Number"
                                                               name="phone"
                                                               required
                                                               InputProps={{
                                                                   startAdornment: (
                                                                       <InputAdornment position="start">
                                                                           <PhoneIcon />
                                                                       </InputAdornment>
                                                                   ),
                                                               }}
                                                        />
                                                    </Grid>
                                                    <h3><Typography className={classes.contactCompanyLabel}>Company information</Typography></h3>
                                                    <Grid item xs={12} sm={12}>
                                                        <Field className={classes.input}
                                                               disabled={isRequested}
                                                               component={TextField}
                                                               name="company"
                                                               type="company"
                                                               label="Company Name"
                                                               required
                                                               InputProps={{
                                                                   startAdornment: (
                                                                       <InputAdornment position="start">
                                                                           <BusinessCenterIcon />
                                                                       </InputAdornment>
                                                                   ),
                                                               }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={12}>
                                                        <Field className={classes.input}
                                                               disabled={isRequested}
                                                               component={TextField}
                                                               type="address"
                                                               label="Address"
                                                               name="address"
                                                               InputProps={{
                                                                   startAdornment: (
                                                                       <InputAdornment position="start">
                                                                           <BusinessIcon />
                                                                       </InputAdornment>
                                                                   ),
                                                               }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={12}>
                                                        <Field className={classes.input}
                                                               disabled={isRequested}
                                                               component={TextField}
                                                               type="website"
                                                               label="Web Site"
                                                               name="website"
                                                               InputProps={{
                                                                   startAdornment: (
                                                                       <InputAdornment position="start">
                                                                           <LanguageIcon />
                                                                       </InputAdornment>
                                                                   ),
                                                               }}
                                                        />
                                                    </Grid>
                                                </Grid>

                                                {props.isMobile && selectedPlan ?
                                                    <Typography className={classes.confidence}>
                                                        <Alert severity="success">Sell with confidence - No commitment, change plan or cancel any time.</Alert>
                                                    </Typography> : null}

                                                <br />
                                                <Button
                                                    className={classes.btnSignUp}
                                                    variant="contained"
                                                    color="primary"
                                                    disabled={isRequested}
                                                    onClick={submitForm}
                                                    type="submit"
                                                >
                                                    Sign Up
                                                </Button>
                                                {isRequested ? <CircularProgress size={20} className={classes.loader}/> : null }
                                            </Form>
                                        )}
                                    </Formik>
                                </div>


                            </Grid>
                        </Grid>

                    </> : <>
                        <Grid container spacing={2} className={classes.grid}>
                            <Grid item xs={12} md={4}>
                                {freePlan}
                            </Grid>
                            <Grid item xs={12} md={4}>
                                {startUpPlan}
                            </Grid>
                            <Grid item xs={12} md={4}>
                                {businessPlan}
                            </Grid>
                        </Grid>
                    </>}
                    {!props.isMobile || !selectedPlan ?
                    <Typography className={classes.confidence}>
                        <Alert severity="success">Sell with confidence - No commitment, change plan or cancel any time.</Alert>
                    </Typography> : null}
                </div> : null}
        </div>
    );
}